/**
 * Typed identifiers for the Space Activation onboarding checklist.
 *
 * The backend stores activation progress as schema-light freeform JSON keyed
 * by sub-step id (see `Space.activation_progress` and `ActivationProgressRaw`
 * in `@models/api/space`). These const-objects + derived types are the FE's
 * single source of truth for the known step/sub-step ids, so producers and
 * consumers can't drift on a string. Sub-step ids are namespaced by their
 * parent step (`<step>.<sub_step>`).
 */

export const ACTIVATION_STEP = {
  SETUP: 'setup',
  ANNOUNCE: 'announce',
  LAUNCH: 'launch',
  PREPARE_EVENT: 'prepare_event',
} as const;
export type ActivationStepId = (typeof ACTIVATION_STEP)[keyof typeof ACTIVATION_STEP];

export const ACTIVATION_SUB_STEP = {
  SETUP_WATCH_VIDEO: 'setup.watch_video',
  SETUP_COMPLETE_SETUP: 'setup.complete_setup',
  SETUP_SEED_POSTS: 'setup.seed_posts',
  ANNOUNCE_SHARE_LINK: 'announce.share_link',
  ANNOUNCE_ANNOUNCE: 'announce.announce',
  ANNOUNCE_INVITE_MEMBERS: 'announce.invite_members',
  LAUNCH_ACTIVATION_KIT: 'launch.activation_kit',
  LAUNCH_LIST_EVENT: 'launch.list_event',
  LAUNCH_ADD_MEETBALL_APP: 'launch.add_meetball_app',
} as const;
export type ActivationSubStepId = (typeof ACTIVATION_SUB_STEP)[keyof typeof ACTIVATION_SUB_STEP];

/** Every known sub-step id — used by the boundary parser to drop unknown keys. */
export const ALL_SUB_STEP_IDS = Object.values(ACTIVATION_SUB_STEP) as ActivationSubStepId[];
